import { ErrorHandler } from '@frontend/error-handler';
import { PinCodeClient } from '@frontend/pin-code/api';
import { PinCode, UpdatePinCode } from '@frontend/pin-code/types';
import { useAccountRepository } from '@frontend/repository';
import { useEffect, useState } from 'react';

import { UpdateMasterPinCodeModalProps } from './update-master-pin-code-modal.component';

export const useUpdateMasterPinCodeModal = (props: UpdateMasterPinCodeModalProps) => {
    const { currentAccount } = useAccountRepository();
    const [formValues, setFormValues] = useState<UpdatePinCode>({});
    const [pinCode, setPinCode] = useState<PinCode | null>(null);

    useEffect(() => {
        if (!props.pin_code_id) return;
        PinCodeClient.fetchPinCode(currentAccount, props.pin_code_id)
            .then((pin) => {
                setFormValues(pin);
                setPinCode(pin);
            })
            .catch((err) => ErrorHandler.handleError({ error: err }));
    }, [props.pin_code_id, currentAccount]);
    return {
        formValues,
        setFormValues,
        pinCode
    };
};
